import { useState, useEffect } from 'react';
import Logo from './Logo';
import './GuestPageHeader.css';

function GuestPageHeader({ organizationName = null, locationName = null }) {
  const [logoSize, setLogoSize] = useState('medium');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setLogoSize('small');
      } else if (window.innerWidth <= 768) {
        setLogoSize('medium');
      } else {
        setLogoSize('medium');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="guest-page-header-professional">
      <div className="guest-header-content-professional">
        <div className="guest-header-logo-section">
          <Logo size={logoSize} variant="light" organizationName={organizationName} locationName={locationName} />
        </div>
      </div>
    </header>
  );
}

export default GuestPageHeader;
